// Models
import { IExerciseData } from 'storage/exercise/models'

// React
import { FC } from 'react'

// Components
import * as Styled from './styled'
import { Exercise } from 'components'

type Props = {
  editMode: boolean
  exercise: IExerciseData
  name: string
  onClickImage?: (exercise: IExerciseData) => void
  onRemove: () => void
  readonly?: boolean
}

const ExerciseForm: FC<Props> = ({
  editMode,
  exercise,
  name,
  onClickImage,
  onRemove,
  readonly,
}) => {
  const cadenceInputName = `${name}.cadence`
  const repetitionInputName = `${name}.repetitions`
  const weightInputName = `${name}.weight`

  return (
    <Styled.Container data-testid="exercise-form-container" editMode={editMode}>
      <Styled.Header>
        <Exercise
          displayMode
          exercise={exercise}
          margin="0 auto 0 0"
          onClick={() => onRemove()}
          onClickImage={onClickImage}
          padding="0"
          transparent
        />

        {editMode && onRemove && (
          <Styled.HiddenButton
            data-testid="exercise-form-remove-button"
            onClick={(event: React.MouseEvent) => {
              event.stopPropagation()
              onRemove()
            }}
          >
            <Styled.DeleteIcon />
          </Styled.HiddenButton>
        )}
      </Styled.Header>

      <Styled.GridInputs
        onClick={(event: React.MouseEvent) => event.stopPropagation()}
      >
        <Styled.InputNumber
          label="Repetição"
          placeholder="0 - 0"
          mask="repetitions"
          name={repetitionInputName}
          readOnly={readonly}
        />

        <Styled.InputNumber
          name={weightInputName}
          label="Carga"
          placeholder="0 kg"
          readOnly={readonly}
          mask="weight"
        />

        <Styled.InputNumber
          name={cadenceInputName}
          label="Cadência"
          placeholder="0000"
          mask="cadence"
          readOnly={readonly}
        />
      </Styled.GridInputs>
    </Styled.Container>
  )
}

export default ExerciseForm
